export default "__VITE_ASSET__362b026d__"